import { t } from "../i18n";
import { SvgIcon } from "./SvgIcon";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const defaultProps = {
  className: '',
  viewBox: '0 0 16 13'
};
export function NextIcon(props) {
  const iconCssClasses = `ds-c-icon--next ${props.className || ''}`;
  return /*#__PURE__*/_jsx(SvgIcon, {
    title: t('icons.next'),
    ...defaultProps,
    ...props,
    className: iconCssClasses,
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 6.667l-6.678 6.666H4.906L9.99 8H0V5.333h9.954L4.897 0h4.436z",
      fillRule: "evenodd"
    })
  });
}